module.exports = __webpack_public_path__ + "static/media/COS_SUPERDIET.47e258a6.webp";